import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { filterByDate, filterByDistance } from 'tennders-stracture/libs/map'
import { apiPost } from 'tennders-stracture/libs/api'
import { REDUX_PROMPT_TYPES } from 'tennders-common/stores/prompt/action'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'

const useAssignTrucks = () => {
  const dispatch = useDispatch()
  const [range, setrange] = useState(5000)
  const [dateRange, setdateRange] = useState(-1)
  const [trucks, setTrucks] = useState([])
  const [loading, setLoading] = useState(false)
  const [allItems, setAllItems] = useState([])
  const [transaction] = useTransactionDetailStore(state => [state.detail])

  const assignTruck = (transaction) => dispatch({
    type: REDUX_PROMPT_TYPES.ASSIGN_TRUCKS,
    payload: transaction
  })

  const filter = useCallback((unfilteredItems) => {
    console.info('item', unfilteredItems)
    let items = filterByDistance(transaction?.pickupRoute?.location, [...unfilteredItems], range)
    console.info('item filter', items, dateRange)
    if (dateRange !== false && dateRange !== -1) {
      items = filterByDate(transaction?.dayDiff, [...items], range)
    } console.info('item filter2', items)

    setTrucks(items)
  }, [transaction?.dayDiff, transaction?.pickupRoute?.location, range, dateRange])

  const fetchTrucks = async (transactionId) => {
    setLoading(true)
    const response = await apiPost('trucks/to-assign', { transaction: transactionId })
    if (response?.items) {
      setAllItems(response?.items)
      filter([...response?.items])
    }
    setLoading(false)
  }

  useEffect(() => {
    filter(allItems)
  }, [allItems, range, dateRange, transaction?.pickupRoute?.location])

  useEffect(() => {
    fetchTrucks(transaction?.id)
  }, [transaction?.id])

  return {
    range,
    setrange,
    trucks,
    loading,
    dateRange,
    setdateRange,
    assignTruck,
    fetchTrucks,
    truckToAssign: transaction
  }
}

export default useAssignTrucks
